import { render, staticRenderFns } from "./ResultManagerCard.vue?vue&type=template&id=77da850c"
import script from "./ResultManagerCard.vue?vue&type=script&lang=js"
export * from "./ResultManagerCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports